import Model from '../orm/Model'
import Input from '../orm/Input'

import Attendance from './Attendance'
import Cancellation from './Cancellation'
import Location from './Location'
import Student from './Student'
import StudentCourse from './StudentCourse'

import { daysOfTheWeek, isEmpty } from '@/utilities'

const courseInput = new Input('CourseInput!', [
    'title',
    'start_time',
    'end_time',
    'crn',
    'subject',
    'course_number',
    'location_id',
    'semester_start',
    'semester_end',
    'meet_sun',
    'meet_mon',
    'meet_tue',
    'meet_wed',
    'meet_thu',
    'meet_fri',
    'meet_sat',
    'late_time',
    'absent_time',
    'min_percentage',
    'alerts_students',
    'manual_attendance',
    'locked'
])

export default class Course extends Model {

    static entity = 'course'

    static fields() {
        return {
            id: this.attr(null),
            uuid: this.attr(null),
            crn: this.attr(null),
            course_number: this.attr(null),
            title: this.attr(''),
            school_id: this.attr(0),
            location_id: this.attr(null),
            location: this.belongsTo(Location, 'location_id'),
            cancellations: this.hasMany(Cancellation, 'course_id'),
            start_time: this.attr(''),
            end_time: this.attr(''),
            semester_start: this.attr(''),
            semester_end: this.attr(''),
            meet_sun: this.attr(false),
            meet_mon: this.attr(false),
            meet_tue: this.attr(false),
            meet_wed: this.attr(false),
            meet_thu: this.attr(false),
            meet_fri: this.attr(false),
            meet_sat: this.attr(false),
            is_in_session: this.attr(null),
            is_archived: this.attr(false),
            late_time: this.attr(null),
            absent_time: this.attr(null),
            min_percentage: this.attr(null),
            alerts_students: this.attr(false),
            manual_attendance: this.attr(false),
            locked: this.attr(false),
            deleted_at: this.attr(null),

            daily_attendance_graph: this.obj({}, 'labels datasets { label data }'),

            attendance_last_class: this.array([], ['label', 'value']),

            missed_last_class: this.array([], ['id', 'uuid', 'semester_apa', 'first_name', 'last_name']),

            student_absent_streak: this.array([], ['uuid', 'semester_apa', 'first_name', 'last_name']),

            students: this.belongsToMany(
                Student, 
                StudentCourse,
                'course_id',
                'student_id'
            ),

            attendance: this.morphMany(Attendance, 
                'attendable_id', 
                'attendable_type')
        }
    }

    days() {
        return daysOfTheWeek(this)
    }

    static graphql = {
        all: {
            type: 'courses',
            paginated: true,
            parameters: {
                page: 'Int',
                per_page: 'Int',
                sort_by: 'String',
                sort_dir: 'String',
                in_session: 'Boolean',
                state: 'String'
            },
            include: { location: true }
        },
        params: {
            type: 'courses',
            paginated: true,
            parameters: {
                query: 'String',
                per_page: 'Int!',
                scoped: 'Boolean',
                state: 'String'
            }
        },
        one: {
            type: 'course',
            parameters: {
                uuid: 'String'
            },
            include: [ 
                'location', 
                'cancellations',
                'attendance_last_class',
                'missed_last_class',
                'student_absent_streak',
                'daily_attendance_graph'
            ]
        },
        create: {
            type: 'createCourse',
            parameters: {
                input: courseInput
            },
            include: {
                location: true
            }
        },
        update: {
            type: 'updateCourse',
            parameters: {
                uuid: 'String!',
                input: courseInput
            },
            include: {
                location: true
            }
        },
        remove: {
            type: 'removeCourse',
            parameters: {
                id: 'Int!'
            }
        },
        scanCode: {
            type: 'course',
            parameters: {
                uuid: 'String!'
            }
        },
        addTeam: {
            type: 'addTeamToCourse',
            parameters: {
                course_id: 'Int!',
                team_id: 'Int!'
            }
        }
    }

    static async $search(params) {
        if (isEmpty(params.query)) return
        if (isEmpty(params.per_page)) {
            params.per_page = 5
        }
        const { data } = await this.$fetch({
            graphql: 'params',
            variables: params
        })

        return data
    }
}